// src/features/collaboration/components/PostFeed.js - UPDATED
import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  Button, 
  Divider,
  CircularProgress,
  Snackbar,
  Alert
} from '@mui/material';
import Post from './Post';
import { Add as AddIcon } from '@mui/icons-material';
import { THEME_COLORS } from '../../../styles/theme';
import { likePost, commentOnPost, trackPostShare } from '../services/collaborationService';
import { useAuth } from '../../../contexts/AuthContext';
import PostCreationInput from './PostCreationInput';

const PostFeed = ({ posts, loading, onCreatePost, onEditPost }) => {
  const { currentUser } = useAuth();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  
  const handleLike = async (postId, userId) => {
    try {
      return await likePost(postId, userId);
    } catch (error) {
      console.error('Error liking post:', error);
      setSnackbar({
        open: true,
        message: 'Failed to like post. Please try again.',
        severity: 'error'
      });
    }
  };
  
  const handleComment = async (postId, commentData) => {
    try {
      return await commentOnPost(postId, commentData.userId, commentData.text);
    } catch (error) {
      console.error('Error posting comment:', error);
      setSnackbar({
        open: true,
        message: 'Failed to post comment. Please try again.',
        severity: 'error'
      });
    }
  };
  
  const handleShare = async (postId, platform) => {
    if (!currentUser?.uid) {
      throw new Error('Please sign in to share posts.');
    }
    
    await trackPostShare(postId, currentUser.uid, platform);
  };
  
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  
  return (
    <Card elevation={2} sx={{ height: '100%', width: '100%', mx: 0, overflow: 'auto', borderRadius: 2 }}>
      <CardContent sx={{ p: 0 }}>
        
      <PostCreationInput onCreatePost={onCreatePost} />

        <Divider sx={{ mb: 0 }} />
        
        {loading ? (
          <Box display="flex" justifyContent="center" mt={4} mb={4}>
            <CircularProgress sx={{ color: THEME_COLORS.primary }} />
          </Box>
        ) : posts.length === 0 ? (
          <Box textAlign="center" mt={4} mb={4}>
            <Typography color="textSecondary">
              No posts yet. Be the first to share something with your network!
            </Typography>
          </Box>
        ) : (
          <Box>
            {posts.map((post) => (
              <Post 
                key={post.id} 
                post={post} 
                onLike={handleLike}
                onComment={handleComment}
                onShare={handleShare}
                onEdit={onEditPost}
              />
            ))}
          </Box>
        )}
      </CardContent>
      
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default PostFeed;
